import { render } from "./AppBrandMark.vue?vue&type=template&id=4751e3ea"
import script from "./AppBrandMark.vue?vue&type=script&lang=js"
export * from "./AppBrandMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AppBrandMark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4751e3ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4751e3ea', __exports__)) {
    api.reload('4751e3ea', __exports__)
  }
  
  module.hot.accept("./AppBrandMark.vue?vue&type=template&id=4751e3ea", () => {
    api.rerender('4751e3ea', render)
  })

}


export default __exports__